import React from "react";
import { toast } from "react-toastify";
import * as hrmsService from "../../../services/hrmsService";
import { EmptyState, LoadState } from "../hrComponents";
import { cardStyle, formatDate, iconBtnStyle, statusBadge, statusLabel, tdStyle, thStyle, useLoad } from "../hrUi";

const linkBtn = { ...iconBtnStyle, fontSize: 13, fontWeight: 600 };

// ROS-07: swap and change requests I made, and swap requests colleagues made of me.
export default function SwapsTab({ myName }) {
  const { data, loading, error, reload } = useLoad(() => hrmsService.listSwaps(false), []);
  const rows = data || [];
  const act = async (fn) => {
    const res = await fn().catch((e) => ({ success: false, message: e.message }));
    if (res?.success) {
      toast.success(res.message || "Saved");
      reload();
    } else toast.error(hrmsService.responseMessage(res));
  };
  return (
    <LoadState loading={loading} error={error} onRetry={reload}>
      {rows.length === 0 ? (
        <EmptyState title="No swap or change requests" text="Ask from My roster, on the day you want to change." />
      ) : (
        <div style={{ ...cardStyle, overflowX: "auto" }}>
          <table className="table mb-0" style={{ minWidth: 560 }}>
            <thead>
              <tr>
                {["Day", "Type", "With", "Status", ""].map((h) => (
                  <th key={h} style={thStyle}>
                    {h}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {rows.map((s) => {
                const asked = s.requester_name === myName;
                return (
                  <tr key={s.id}>
                    <td style={tdStyle}>{formatDate(s.swap_date)}</td>
                    <td style={tdStyle}>{s.swap_type === "SWAP" ? "Swap" : "Change"}</td>
                    <td style={tdStyle}>{s.swap_type === "SWAP" ? (asked ? s.peer_name : `${s.requester_name} asks you`) : "—"}</td>
                    <td style={tdStyle}>
                      <span style={statusBadge(s.status === "APPROVED" ? "APPROVED" : ["REJECTED", "DECLINED"].includes(s.status) ? "REJECTED" : ["WITHDRAWN", "CANCELLED"].includes(s.status) ? "WITHDRAWN" : "PENDING")}>{statusLabel(s.status)}</span>
                    </td>
                    <td style={{ ...tdStyle, textAlign: "right", whiteSpace: "nowrap" }}>
                      {s.status === "PENDING_PEER" && !asked ? (
                        <>
                          <button type="button" style={linkBtn} onClick={() => act(() => hrmsService.respondToSwap(s.id, true))}>
                            Accept
                          </button>{" "}
                          <button type="button" style={linkBtn} onClick={() => act(() => hrmsService.respondToSwap(s.id, false))}>
                            Decline
                          </button>
                        </>
                      ) : null}
                      {asked && ["PENDING_PEER", "PENDING_APPROVAL"].includes(s.status) ? (
                        <button type="button" style={linkBtn} onClick={() => act(() => hrmsService.withdrawSwap(s.id))}>
                          Withdraw
                        </button>
                      ) : null}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </LoadState>
  );
}
